/* eslint-disable @typescript-eslint/no-explicit-any */
// VENDOR
import { Notify, Dialog } from 'quasar';

// Personal
import QDialogTemplate from '@components/template/QDialogTemplate.vue';
import { DialogSizeEnum } from '@shared/enum/dialog-size.enum';
import { NotificationTypeEnum } from '@shared/enum/notification.enum';
import { IDialogCreateOption } from '@shared/interface/quasar.interface';
import { IQDialogButton } from '@shared/interface/qDialogTemplate.interface';

export interface IDisplayNotificatonParam {
  caption?: string;
  isHtml?: boolean;
  timeOut?: number;
}

const defaultDialogParam: IDisplayCustomDialogParam = {
  isHtml: false,
  notificationType: NotificationTypeEnum.SUCCESS,
};

/**
 * Private: display notification via Dialog plugin
 * @param param
 */
interface IDisplayCustomDialogParam {
  title?: string;
  message?: string;
  isHtml?: boolean;
  notificationType?: NotificationTypeEnum;
  okBtn?: IQDialogButton;
  cancelBtn?: IQDialogButton;
  dialogSize?: DialogSizeEnum;
  onOk?: () => void;
  onCancel?: () => void;
}

export const displayCustomDialog = (params: IDisplayCustomDialogParam) => {
  const option: IDialogCreateOption = {
    component: QDialogTemplate,

    componentProps: {
      title: params.title,
      message: params.message,
      isHtml: params.isHtml,
      maximized: false,
      dialogSize: params.dialogSize,
      notificationType: params.notificationType,
      cancelBtn: params.cancelBtn,
      okBtn: params.okBtn,
    },
  };

  return Dialog.create(option);
};

/**
 * ************************************************************************************************
 * DIALOGS
 * ************************************************************************************************
 */

export function displayDialogSuccess(
  params: IDisplayCustomDialogParam = defaultDialogParam,
) {
  return displayCustomDialog({
    title: params.title,
    message: params.message,
    isHtml: params.isHtml,
    dialogSize: DialogSizeEnum.EXTRA_SMALL,
    notificationType: NotificationTypeEnum.SUCCESS,
    cancelBtn: params.cancelBtn,
    okBtn: params.okBtn,
  });
}

export function displayDialogError(
  params: IDisplayCustomDialogParam = defaultDialogParam,
) {
  return displayCustomDialog({
    title: params.title,
    message: params.message,
    isHtml: params.isHtml,
    dialogSize: DialogSizeEnum.EXTRA_SMALL,
    notificationType: NotificationTypeEnum.ERROR,
    cancelBtn: params.cancelBtn,
    okBtn: params.okBtn,
  });
}

export function displayDialogWarning(
  params: IDisplayCustomDialogParam = defaultDialogParam,
) {
  return displayCustomDialog({
    title: params.title,
    message: params.message,
    isHtml: params.isHtml,
    dialogSize: DialogSizeEnum.EXTRA_SMALL,
    notificationType: NotificationTypeEnum.WARNING,
    cancelBtn: params.cancelBtn,
    okBtn: params.okBtn,
  });
}

/**
 * ************************************************************************************************
 * NOTIFICATIONS
 * ************************************************************************************************
 */
interface IDisplayNotifOptions {
  progress?: boolean;
  timeout?: number;
  position?:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'top-left'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-right'
    | 'center'
    | undefined;
  isHtml?: boolean;
  group?: boolean | string | number;
}
const defaultOptions: IDisplayNotifOptions = {
  progress: true,
  isHtml: false,
  timeout: 3000,
};
export function displayNotifSuccess(
  message,
  options: IDisplayNotifOptions = defaultOptions,
) {
  const newOptions = Object.assign({ ...defaultOptions }, options);

  Notify.create({
    progress: newOptions.progress,
    timeout: newOptions.timeout,
    message: message,
    position: newOptions.position,
    icon: 'done',
    actions: [
      {
        icon: 'close',
        color: 'black',
        class: 'set-outline',
        title: 'Fermer la notification',
      },
    ],
    color: 'positive',
    html: newOptions.isHtml,
    badgeClass: 'invisible',
    textColor: 'black',
    attrs: {
      role: 'status',
    },
  });
}

export function displayNotifWarning(
  message,
  options: IDisplayNotifOptions = defaultOptions,
) {
  const newOptions = Object.assign({ ...defaultOptions }, options);

  Notify.create({
    progress: newOptions.progress,
    timeout: newOptions.timeout,
    message: message,
    position: newOptions.position,
    icon: 'warning',
    actions: [
      {
        icon: 'close',
        color: 'black',
        class: 'set-outline',
      },
    ],
    color: 'orange',
    html: newOptions.isHtml,
    group: newOptions.group,
    badgeClass: 'invisible',
    textColor: 'black',
    attrs: {
      role: 'alert',
    },
  });
}

export function displayNotifError(
  message,
  options: IDisplayNotifOptions = defaultOptions,
) {
  const newOptions = Object.assign({ ...defaultOptions }, options);

  Notify.create({
    progress: newOptions.progress,
    timeout: newOptions.timeout,
    message: message,
    position: newOptions.position,
    icon: 'error',
    actions: [
      {
        icon: 'close',
        color: 'black',
        class: 'set-outline',
      },
    ],
    color: 'red',
    html: newOptions.isHtml,
    badgeClass: 'invisible',
    textColor: 'black',
    attrs: {
      role: 'alert',
    },
  });
}
